import { BankCard } from './bank-card.model';

export type Payment = BankCard;

export enum PaymentModeCodes {
  Sbrf = 'sbrf',
  CashCardReceive = 'cash_card_receive',
  CardDelivery = 'card_delivery',
  CashDelivery = 'cash_delivery',
  CashCardShop = 'cash_card_shop',
  Sbp = 'sbp',
  Plait = 'plait',
  QrDelivery = 'qr_delivery',
}

export interface PaymentParams {
  paymentInfo?: string;
  paymentMode?: PaymentModeCodes;
}
